import React, {useEffect, useState} from 'react';

import "react-datepicker/dist/react-datepicker.css";
import {useSearchParams} from "react-router-dom";
import {Button, Container} from "react-bootstrap";
import {regularTextStyles, subHeadingStyles} from "../Style";
import handleCreditCardPayment from "./CreditCardPayment";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import Cookies from "js-cookie";

const CreditCardPaymentFailure = (props) => {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(true);
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [inputValues, setInputValues] = useState({
    id: ''
  });
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
      ? 'carAutosureEvent'
      : window.location.href.includes('quashed')
          ? 'carQuashedEvent'
          : window.location.href.includes('better')
              ? 'carBetterEvent'
              : window.location.href.includes('simplify')
                  ? 'carSimplifyEvent'
                  : '';
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Submit',
        'categoryDetails': 'Direct Debit - Credit',
        'status': 'Fail',
        'virtualUrl': `${baseUrl}/vehicle/step5`,
        'pageTitle': 'Payment',
      });

  }, []);
  const proceedWithPayment = async () => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let id = encodeURIComponent(params.get('uuid'));
    setInputValues({
      id: id
    });
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    const isRecaptchaV2Verified = Cookies.get('AUTHENTICATED_V2');
    if (isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    handleCreditCardPayment({inputValues}, token);
  }
  const onClickRedirectTFAF = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let renewalId = encodeURIComponent(params.get('uuid'));
    let token = encodeURIComponent(params.get('token'));
    window.location.href = `/vehicle?id=${renewalId}&token=${token}`;
  }
  //let url = 'http://localhost:8080/edge';
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';


  return (
      <>
        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
          <Container fluid style={{flex: 1}}>
            <Container>
              <br/><br/>
              <p style={subHeadingStyles}>Oops!</p>
              <p style={regularTextStyles}>Sorry your payment has not been successful. Please try
                entering your credit card details again.</p>

              <Button variant="primary" onClick={proceedWithPayment} style={{width: "180px"}}>
                Proceed to payment
              </Button><br/><br/>
              <Button variant="secondary" onClick={onClickRedirectTFAF} style={{width: "180px"}}>
                Go back to quote
              </Button>
              <br/><br/>
              <p style={regularTextStyles}>Thanks</p>

              <p style={regularTextStyles}>Autosure Car Insurance Team</p>
            </Container>
          </Container>
        </div>
      </>
  );

}

export default CreditCardPaymentFailure;
